import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackSpecialProjectClick } from './tracking';
import { SpecialPromoLink } from '../../components/SpecialPromoLink';
import { SPECIAL_PROJECTS } from '../../constants/specialProjects';
import { selectSpecialProject, selectSpecialPromoInfo } from '../../selectors';
import { ISpecialProjectItemSchema } from '../../types/offerData';
import { getSpecialPromoLink } from '../../utils/specialProjects';

export const SpecialPromoLinkContainer = () => {
  const specialProject = useSelector(selectSpecialProject);
  const specialPromoInfo = useSelector(selectSpecialPromoInfo);

  const specialProjectData = specialProject && SPECIAL_PROJECTS[specialProject.id];

  const handleSpecialProjectClick = React.useCallback(() => {
    trackSpecialProjectClick((specialProject as ISpecialProjectItemSchema).id);
  }, [specialProject]);

  if (specialProjectData) {
    return (
      <SpecialPromoLink
        onClick={handleSpecialProjectClick}
        logo={specialProjectData.icon}
        text={specialProjectData.text}
        url={specialProject.link}
      />
    );
  }

  if (specialPromoInfo) {
    return (
      <SpecialPromoLink
        logo={specialPromoInfo.logoSmallUrl}
        text={specialPromoInfo.textShowOffers}
        url={getSpecialPromoLink(specialPromoInfo)}
      />
    );
  }

  return null;
};
